/* eslint-disable @typescript-eslint/no-empty-function */
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {
  Box,
  CardMedia,
  Divider,
  Grid,
  Hidden,
  Link,
  Popover,
  Skeleton,
  Stack,
  Switch,
  Typography,
  Button,
  Theme,
  useTheme,
  Tooltip,
  IconButton,
} from '@mui/material';
import { margin, SxProps } from '@mui/system';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { getAssetAllocation, getAumDistribution, getAumDistributionChart, getCastHistory, getRMDashBoardMetrics, getRMNewDashBoard } from '../../redux-store/actions/userManagement';
import { RootStateType } from '../../redux-store/reducers';
import {
  AssetAllocationEntity,
  AumChart,
  GetCashHistory,
  NewDashBoardCard,
  NewRmDashBoardType,
  ProductAllocationEntity,
  RmDashBoardGraph,
  RmDashboardType,
  aumDistributionChart,
  filterType,
} from '../../redux-store/types/api-types';
import { AmountUnit, CommonLayout, CopyGraphDropdown, PopoverValue } from '../commonComponents';
import { calculateOthersInPieChart, formatCurrency, formatNumberWithRupeeSymbol, formatToIndianCurrency, maskInfo, toINR } from '../../utils/utilityFunctions';
import {
  AccountsIcon,
  CashAvailableIcon,
  FlipIcon,
  TotalAUMIcon,
  TotalHoldingsIcon,
} from '../customSVGs';
import { preventOverflow } from '@popperjs/core';
import { useReactToPrint } from 'react-to-print';
import { ColumnType, DataTable } from '../DataTable';
import SaveAltRoundedIcon from '@mui/icons-material/SaveAltRounded';
import CustomePieChart from './chart/CustomePieChart';
import CustomeLineChart, { ErrorText } from './chart/CustomeLineChart';
import MFSelectField from '../../lib/formik/SelectField';
import CustomDropdown from '../../lib/formik/CustomDropdown';
import { LocationDescriptor } from 'history';
import Account from './table/Account';
import WorldMap from './WorldMap';
import { filteringAum } from '../../utils/filtering';
import useAumTableHook from '../CustomeHook/useAumTableHook';
import moment from 'moment';
import CardChart from './chart/CardChart';
import { GraphSvg, InfoIconOutlined } from '../../assets/SvgIcons';



export const scrollbarView = {
  '::-webkit-scrollbar': {
    width: '16px',
    background: 'white',
  },
  '::-webkit-scrollbar-thumb': {
    background: '#4990F0',
    borderRadius: '10px',
    width: '16px',
    boxShadow: 'none',
  },
  '::-webkit-scrollbar-track': {
    background: '#D6E7FE',
    borderRadius: '10px',
    borderRight: '7px solid transparent',
    borderLeft: '7px solid transparent',
    backgroundClip: 'padding-box',
    width: '2px',
  },
};
export function InfoCard({
  label,
  value,
  onClick,
  isLoading,
  sx,
  color = '#1473CC',
  icon,
  chartData
}: {
  label: string | undefined;
  value: string | number;
  color?: string;
  onClick?: () => void;
  isLoading?: boolean;
  sx?: SxProps;
  icon?: JSX.Element | React.ReactNode;
  chartData?: Array<any>
}): JSX.Element {

  // console.log(label, chartData)
  return (
    <Box sx={(theme: Theme) => ({
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      columnGap: '1rem',
      padding: { xs: '20px 12px', sm: '14px 14px', md: '16px 16px', lg: "18px 16px", xl: '20px 16px' },
      boxShadow: '0px 4px 10px rgb(0 0 0 / 5%)',
      borderRadius: '20px',
      background: theme.palette.common.white,
      [theme.breakpoints.up(1550)]: {
        padding: '25px 18px'
      }
      // width: ['45%', '30%', 'calc(100% / 3 - 10px)', 'calc(100% / 3 - 110px)'],
      // [theme.breakpoints.up(1540)]: {
      //   width: '32%',
      // },
    })}>
      {/* <Link
        onClick={onClick}
        sx={{
          pointerEvents: isLoading ? 'none' : 'unset',
          cursor: onClick ? 'pointer' : 'unset',
          color: '#fff',
          display: 'block',
          textDecoration: 'none',
          padding: { sm: '15px 18px', md: '20px 18px', lg: "25px 18px" },
          background: '#FFFFFF',
          // borderColor: color,
          boxShadow: '0px 4px 10px rgb(0 0 0 / 5%)',
          borderRadius: '20px',
          ...sx,
          // '&:hover,&:focus': {
          //   boxShadow: onClick ? '0px 2px 10px rgb(0 0 0 / 20%)' : '0px 2px 10px rgb(0 0 0 / 8%)',
          // },
        }}> */}
      <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '1rem', }}>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {icon}
        </Box>
        <Box >
          <Typography
            variant='body_500'
            sx={(theme: Theme) => (
              {
                mb: '10px',
                mt: '-5px',
                width: isLoading ? '90px' : 'unset',
                color: 'text.primary',
                // fontSize: ['16px', '14px', '14px', '14px', '14px'],
                // fontWeight: 500,
                // lineHeight: '14px',
                // [theme.breakpoints.up(1550)]: {
                //   fontSize: '16px'
                // }
              }
            )}>
            {isLoading ? <Skeleton /> : label}
          </Typography>
          <Typography
            variant='body_700'
            sx={(theme: Theme) => (
              {
                width: isLoading ? '100px' : 'unset',
                color: 'text.primary',
                // fontSize: ['20px', '15px', '16px', '16px', '16px'],
                // fontWeight: 600,
                // lineHeight: '14px',
                // [theme.breakpoints.up(1550)]: {
                //   fontSize: '20px'
                // }
              }
            )}>
            {isLoading ? <Skeleton /> : value}
          </Typography>
        </Box>
        {/* <GraphSvg /> */}
      </Box>
      {chartData &&
        <CardChart data={chartData?.map(item => [(item?.month || item?.week), item?.lastData])} />
      }

      {/* </Link > */}
    </Box >
  );
}

function ValuePopOver({
  valueType,
  percent: percentProp,
  value,
  assetName,
  popoverContent,
  color = '#67ADF1',
  gainlossPercent = 0,
}: {
  valueType: string;
  percent: number;
  value: number;
  assetName: string;
  popoverContent?: JSX.Element | React.ReactNode;
  color?: string;
  gainlossPercent?: number;
}) {
  const positiveGainLossPercent = Math.abs(gainlossPercent);
  const [percent, setPercent] = useState(0);
  useEffect(() => {
    if (percentProp > 0) {
      setTimeout(() => setPercent(percentProp), 0);
    }
  }, [percentProp]);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  const open = Boolean(anchorEl);

  return (
    <>
      <Box
        aria-owns={open ? 'mouse-over-popover' : undefined}
        aria-haspopup="true"
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        sx={{
          display: 'flex',
          justifyContent: valueType === 'invested' ? 'flex-end' : 'flex-start',
          width: '100%',
          position: 'relative',
          pr: valueType === 'invested' ? 2.5 : 0,
          pl: valueType === 'invested' ? 0 : 2.5,
          '&::after': {
            content: '""',
            width: '7px',
            height: '7px',
            borderRadius: '50%',
            background: color,
            position: 'absolute',
            right: valueType === 'invested' ? 0 : 'unset',
            left: valueType === 'invested' ? 'unset' : 0,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
          },
          '&::before': {
            content: '""',
            width: '20px',
            height: '1px',
            borderBottom: '1px dashed',
            borderColor: color,
            position: 'absolute',
            right: valueType === 'invested' ? 0 : 'unset',
            left: valueType === 'invested' ? 'unset' : 0,
            top: '50%',
            transform: 'translateY(-50%)',
            zIndex: 1,
          },
        }}>
        <Box
          sx={{
            fontSize: 11,
            fontWeight: 500,
            color: '#fff',
            px: 1.2,
            py: 0.6,
            position: 'relative',
            width: `${percent}%`,
            transition: 'width 0.5s ease',
            borderRadius: valueType === 'invested' ? ' 20px 0px 0px 20px' : '0px 20px 20px 0px',
            cursor: 'pointer',
          }}>
          <Box
            sx={{
              borderRadius: 'inherit',
              position: 'absolute',
              left: 0,
              top: 0,
              bottom: 0,
              right: 0,
              overflow: 'hidden',
            }}>
            <Box
              sx={{
                position: 'absolute',
                width: `${positiveGainLossPercent
                  ? percent < 10
                    ? 100 - positiveGainLossPercent - percent
                    : percent < 50 &&
                      percent / positiveGainLossPercent < 4 &&
                      percent / positiveGainLossPercent > 2
                      ? 100 + positiveGainLossPercent - percent
                      : 100 - positiveGainLossPercent
                  : 100
                  }%`,
                background: color,
                top: 0,
                bottom: 0,
                left: 0,
                zIndex: 1,
              }}
            />
            <Box
              sx={{
                position: 'absolute',
                width: '100%',
                borderRadius: 'inherit',
                backgroundColor: gainlossPercent < 0 ? '#E89292' : '#8ED8B7',
                top: 0,
                left: 0,
                bottom: 0,
                zIndex: 0,
              }}></Box>
          </Box>

          <span
            style={{
              position: 'absolute',
              color: percent < 10 ? '#22242C' : 'inherit',
              right:
                valueType === 'invested'
                  ? percent < 10
                    ? `${100 - (percent - 10)}%`
                    : 0
                  : 'unset',
              left:
                valueType === 'invested' ? 'unset' : percent < 10 ? `${100 - (percent - 10)}%` : 0,
              zIndex: 2,
            }}>
            {percent}%
          </span>
          <span style={{ visibility: 'hidden' }}>0</span>
        </Box>
      </Box>
      <Popover
        id="mouse-over-popover"
        sx={{
          pointerEvents: 'none',
          left: valueType === 'invested' ? -20 : 20,
        }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: valueType === 'invested' ? 'right' : 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: valueType === 'invested' ? 'left' : 'right',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus>
        {popoverContent ? (
          popoverContent
        ) : (
          <Box sx={{ p: 1 }}>
            <PopoverValue label={assetName} color={color} amount={value} percent={percent} />
          </Box>
        )}
      </Popover>
    </>
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function AssetAllocationCard({
  label,
  onClickLabel = () => { },
  investedPercent,
  currentPercent,
  investedValue,
  currentValue,
  xirr,
  isLoading,
  link,
  labelStyles,
  leftPopoverContent,
  rightPopoverContent,
  leftBarColor,
  rightBarColor,
}: {
  label: string;
  onClickLabel?(): void;
  investedPercent: number | string;
  currentPercent: number | string;
  investedValue: number | string;
  currentValue: number | string;
  xirr?: number | null;
  isLoading?: boolean;
  link?: string;
  labelStyles?: SxProps;
  leftPopoverContent?: JSX.Element | React.ReactNode;
  rightPopoverContent?: JSX.Element | React.ReactNode;
  leftBarColor?: string;
  rightBarColor?: string;
}) {
  const history = useHistory();
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', width: '100%', mb: 3.5 }}>
      <Box style={{ width: '50%', textAlign: 'right' }}>
        {isLoading ? (
          <Skeleton />
        ) : (
          <ValuePopOver
            popoverContent={leftPopoverContent}
            color={leftBarColor ? leftBarColor : '#67ADF1'}
            valueType="invested"
            percent={Number(investedPercent)}
            value={Number(investedValue)}
            assetName={label}
          />
        )}
      </Box>
      <Box style={{ width: 150, textAlign: 'center' }}>
        {isLoading ? (
          <Skeleton sx={{ width: 80, margin: 'auto' }} />
        ) : (
          <Typography
            sx={{
              fontSize: { md: 12, lg: 14 },
              lineHeight: '16px',
              color: '#22242C',
              opacity: 0.8,
              padding: '5px 12px',
              // border: '1px solid #0BAAE7',
              borderRadius: '5px',
              // width: 150,
              whiteSpace: 'nowrap',
              margin: 'auto',
              ...labelStyles,
            }}
            onClick={onClickLabel}>
            {label}
          </Typography>
        )}
      </Box>
      <Box style={{ width: '50%' }}>
        {isLoading ? (
          <Skeleton />
        ) : (
          <ValuePopOver
            popoverContent={rightPopoverContent}
            gainlossPercent={xirr !== null ? xirr : undefined}
            color={rightBarColor ? rightBarColor : '#8ED8B7'}
            valueType="current"
            percent={Number(currentPercent)}
            value={Number(currentValue)}
            assetName={label}
          />
        )}
      </Box>
    </Box>
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function RevenuePercent({
  label,
  percent: percentProp,
  amount,
  color,
  isLoading,
  popOverAmt,
  sx,
}: {
  label: string;
  percent: number;
  amount: string;
  color: string;
  isLoading: boolean;
  popOverAmt?: number;
  sx?: SxProps;
}) {
  const [percent, setPercent] = useState(0);
  const [anchorEl, setAnchorEl] = React.useState<HTMLElement | null>(null);
  const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handlePopoverClose = () => {
    setAnchorEl(null);
  };
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setTimeout((_) => setPercent(percentProp), 0);
  }, [percentProp]);
  const open = Boolean(anchorEl);
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        pb: 3.75,
        ...sx,
      }}>
      {isLoading ? (
        <Skeleton sx={{ width: 150 }} />
      ) : (
        <Typography
          className="left"
          sx={{
            fontSize: 13,
            lineHeight: '15px',
            fontWeight: 400,
            color: '#1E346B',
            opacity: 0.8,
            textAlign: 'right',
            width: 150,
            mr: 4,
          }}>
          {label}
        </Typography>
      )}
      <Box
        className="progress-bar"
        onMouseEnter={popOverAmt ? handlePopoverOpen : () => { }}
        onMouseLeave={handlePopoverClose}
        sx={{
          flexGrow: 1,
          position: 'relative',
          overflowX: 'hidden',
          zIndex: 9,
          '&::after': {
            content: '" "',
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            width: '100%',
            height: '1px',
            borderBottom: '2px dashed rgba(0,0,0,0.1)',
            zIndex: 1,
          },
        }}>
        {isLoading ? (
          <Skeleton sx={{ width: '90%', margin: 'auto' }} />
        ) : (
          <Box
            aria-owns={open ? 'mouse-over-popover' : undefined}
            aria-haspopup="true"
            sx={{
              background: color,
              width: `100%`,
              transform: `translateX(-${100 - percent}%)`,
              transition: 'transform 0.5s ease',
              borderRadius: '0px 20px 20px 0px',
              cursor: 'pointer',
              height: 14,
              position: 'relative',
              zIndex: 2,
            }}></Box>
        )}
        <Popover
          id="progress-bar-popover"
          sx={{
            pointerEvents: 'none',
            left: 0,
          }}
          PaperProps={{
            sx: {
              background: '#FFFFFF',
              boxShadow: '0px 4px 40px 4px rgba(0, 0, 0, 0.07)',
              borderRadius: '3px',
              padding: '10px',
            },
          }}
          open={open}
          anchorEl={anchorEl}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          onClose={handlePopoverClose}
          disableRestoreFocus>
          <PopoverValue
            label={label}
            amount={popOverAmt ? formatToIndianCurrency(popOverAmt) : 'NA'}
            color={color}
            percent={percent}
          />
        </Popover>
      </Box>
      {isLoading ? (
        <Skeleton sx={{ width: 50 }} />
      ) : (
        <Typography
          className="right"
          sx={{
            fontSize: 13,
            fontWeight: 400,
            color: '#101010',
            opacity: 0.8,
            width: 80,
            ml: 3.5,
          }}>
          {amount || 'NA'}
        </Typography>
      )}
    </Box>
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function ProgressBarIntervals({ sx }: { sx?: SxProps }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 2, ...sx }}>
      <Typography className="left" sx={{ width: 150, mr: 4 }}></Typography>
      <Box
        className="progress-bar"
        sx={{ flexGrow: 1, display: 'flex', justifyContent: 'space-between' }}>
        {[0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((item, index) => (
          <Typography
            key={index}
            sx={{
              fontSize: 12,
              fontWeight: 400,
              color: '#22242C',
              opacity: 0.4,
              lineHeight: '14px',
            }}>
            {item}
          </Typography>
        ))}
      </Box>
      <Typography className="right" sx={{ width: 80, ml: 3.75 }}></Typography>
    </Box>
  );
}

export default function Dashboard(): JSX.Element {
  const history = useHistory();
  const { palette, typography } = useTheme()


  const [isLoading, setLoading] = useState(true);
  const [assetLoading, setAssetLoading] = useState(true)

  const [selectedAssetsType, setSelectedAssetsType] = useState<'product' | 'assetClass'>('product');
  const { role = '' } = useSelector((store: RootStateType) => store.auth);
  const id = useSelector((store: RootStateType) => store.id);
  const valueConverter = useSelector((state: any) => state.valueConverter);
  const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);
  const [dashBoardMetricsData, setDashBoardMetricsData] = useState<NewRmDashBoardType>({} as NewRmDashBoardType);
  const [dashBoardGraphData, setDashBoardGraphData] = useState<RmDashBoardGraph>({});
  const [flip, setFlip] = useState(false);
  const [filterValue, setFilterValue] = useState<string | number>(1);
  const [assetFilter, setassetFilter] = useState<string | number>(1)
  const [aumData, setAumData] = useState<{ aum: { family: any; individual: any }, filterOption: filterType[] }>({} as { aum: { family: any; individual: any }, filterOption: filterType[] });
  const [accountTable, setAccountTable] = useState<any>([]);
  const [cards, setCard] = useState<Array<GetCashHistory>>([]);
  const [exportData, setExportData] = useState<any>([])

  //error status
  const [aumDistributionError, setAumDistributionError] = useState(false);
  const [castHistoryError, setCastHistoryError] = useState(false);
  const [assetAllocationError, setAssetAllocationError] = useState(false)
  const [pieChartError, setpieChartError] = useState(false)

  const [cardFilter, setCardFilter] = useState<string | number>(1);
  const [assetAllocation, setAssetAllocation] = useState<any>([])


  const dispatch = useDispatch();
  const { getAumTable } = useAumTableHook()
  const componentRef = React.useRef<HTMLDivElement>(null);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  useEffect(() => {
    let isComponentActive = true;
    setDashBoardMetricsData({} as NewRmDashBoardType);
    // new thing
    // setDashBoardGraphData({} as RmDashBoardGraph);
    (async function () {
      if (id.iwappRmId) {
        try {
          setLoading(true);
          setAssetLoading(true);


          try {

            // if (id.iwappRmId) {
            const [res2, res3]: any = await Promise.all([
              dispatch(getAumDistributionChart({ rmId: id.iwappRmId })) as unknown | Array<AumChart>,
              dispatch(getCastHistory({ rmId: id.iwappRmId })) as unknown | Array<GetCashHistory>
            ]);

            if (res2?.isSuccess) {
              const modifiedRes = {
                ...res2, result: res2?.result?.map((ele: any) => ({
                  ...ele,
                  customerName: maskInfo(ele?.customerName),
                  // familyName: maskInfo(ele?.familyName)
                })) ?? []
              }
              setExportData(modifiedRes?.result as any);
              setAccountTable(getAumTable(modifiedRes?.result as Array<AumChart>))

              // this modification for line chart
              const modifiedRes2 = {
                ...res2, result: res2?.result?.map((ele: any) => ({
                  ...ele,
                  customerName: maskInfo(ele?.customerName),
                  familyName: maskInfo(ele?.familyName)
                }))
              }
              setAumData(filteringAum(modifiedRes2?.result as Array<AumChart>) as any);
            } else {
              setAumData({
                aum: {
                  family: {
                    name: [], value: []
                  }, individual: {
                    name: [], value: []
                  }
                }, filterOption: []
              })
              setAumDistributionError(true)
            }

            if (res3?.isSuccess) {
              setCard(res3?.result as Array<GetCashHistory>);
            } else {
              setCastHistoryError(true)
            }


            // }
          } catch (e) {
            console.log("error", e)
            setAssetAllocationError(true)
            setAumDistributionError(true)
            setCastHistoryError(true)
          }
          if (!isComponentActive) {
            return;
          }
          // setDashBoardMetricsData(response as NewRmDashBoardType);
          // new thing
          // setDashBoardGraphData(res1 as RmDashBoardGraph);

          setAssetLoading(false);
          setLoading(false);
        } catch (e) {
          setAssetLoading(false);
          setLoading(false);
          console.log((e as Error).message);
        }
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [id.iwappRmId]);

  useEffect(() => {

    const fetch = async () => {

      try {
        setAssetLoading(true);
        const res4: any = (await dispatch(getAssetAllocation({ category: assetFilter === 1 ? "Asset Group" : "Asset Class", rmId: id.iwappRmId }))) as unknown | Array<AumChart>;
        if (res4.isSuccess) {
          setAssetAllocation({ ...res4?.result, result: { ...res4?.result } })
          setAssetLoading(false)
        } else {
          setAssetLoading(false)
          setAssetAllocation({
            data: [],
          })
          setpieChartError(true)

        }


      } catch (e) {
        console.log("error", e)
        setAssetLoading(false)
        setAssetAllocation({
          data: [],
        })
        setpieChartError(true)
      }
    }

    if (id.iwappRmId && assetFilter) fetch()

  }, [assetFilter, id.iwappRmId])

  // useEffect(() => {

  //   const last7DayStart = moment().startOf('day').subtract(1, 'week');
  //   const lastMonthThisDay = moment().startOf('day').subtract(1, 'month');
  //   const yesterdayEndOfRange = moment().endOf('day').subtract(1, 'day');


  //   if (cardFilter === 1) {
  //     setShowCard([...cards]?.filter((item: GetCashHistory) => moment(parseInt(item.navDate), "YYYYMMDD").isBetween(last7DayStart, yesterdayEndOfRange)))
  //   } else {
  //     setShowCard([...cards]?.filter((item: GetCashHistory) => moment(parseInt(item.navDate), "YYYYMMDD").isBetween(lastMonthThisDay, yesterdayEndOfRange)))
  //   }
  // }, [cardFilter])

  const momentDates = [...cards].map(obj => moment(obj.navDate, 'YYYYMMDD'));

  // Find the index of the latest date
  const latestIndex = momentDates.reduce((acc, curr, index) => (curr.isAfter(momentDates[acc]) ? index : acc), 0);

  // Get the object with the latest date
  const latestObject = cards[latestIndex];

  const startDate = moment();
  const endDate = moment().subtract(5, 'years');

  // Filter data within the specified date range
  const lastYearData = [...cards].filter(item => {
    const navDate = moment(item.navDate, "YYYYMMDD");
    return navDate.isBetween(endDate, startDate, null, "[]"); // Reversed start and end dates
  });

  const StartingDateinapi = moment(cards[0]?.navDate, "YYYYMMDD"); const LastEndingDateinapi = moment(cards[cards.length - 1]?.navDate, "YYYYMMDD").subtract(1, 'week');

  function filterDates(type: "week" | "month") {
    const EndingDateinapi = moment(cards[cards.length - 1]?.navDate, "YYYYMMDD").subtract(1, type);

    const lastData = [...cards].filter(item => {
      const navDate = moment(item.navDate, "YYYYMMDD");
      return navDate.isSameOrAfter(EndingDateinapi);
    });

    return lastData
  }

  // console.log('week', filterDates("week"), filterDates('week').reduce((prev, curr) => prev + curr?.noOfPortfolios, 0))
  // console.log('month', filterDates("month"), filterDates('month').reduce((prev, curr) => prev + curr?.noOfPortfolios, 0))

  const separateDataByMonth = (data: any[], key: "netAssets" | "cashBalance" | "noOfPortfolios" | "noOfHoldings") => {
    const monthly: { month: string, lastData: number }[] = [];
    const weekly: { week: string, lastData: number }[] = [];

    // console.log('data', data)

    // Sort the array based on navDate
    const sortedData = [...data].sort((a, b) => a.navDate - b.navDate);

    const letestDate = sortedData[sortedData.length - 1]?.navDate;
    // console.log('letestDate', letestDate, sortedData);

    const startingMonthDate = moment(letestDate, 'YYYYMMDD').subtract(1, 'month');
    const startingWeekDate = moment(letestDate, 'YYYYMMDD').subtract(1, 'week');

    const month = [...sortedData].filter(obj => moment(obj.navDate, 'YYYYMMDD').isSameOrAfter(startingMonthDate));
    const week = [...sortedData].filter(obj => moment(obj.navDate, 'YYYYMMDD').isSameOrAfter(startingWeekDate));

    // console.log('month', month);
    // console.log('week', week);

    month.map((item, index) => {
      monthly.push({ month: moment(item.navDate, 'YYYYMMDD').format('DD/MM/YYYY'), lastData: item[key] });
    })

    week.map((item, index) => {
      weekly.push({ week: moment(item.navDate, 'YYYYMMDD').format('DD/MM/YYYY'), lastData: item[key] });
    })

    // console.log({ monthly, weekly })
    return { monthly, weekly };
  };
  // console.log(latestObject);


  // console.log('card', [...cards]?.filter((item: GetCashHistory) => console.log('item', moment(parseInt(item.navDate), 'YYYYMMDD').subtract(7, 'days').hours(0).format('DD/MM/YYYY'))));

  // const productTableHeaders = (): ColumnType[] => {
  //   return [
  //     {
  //       header: 'Product Name',
  //       sortingKey: 'ProductLevel',
  //       valueGetter: (row: ProductAllocationEntity) => row?.ProductLevel,
  //     },
  //     {
  //       header: 'Invested Value',
  //       sortingKey: 'PurVal',
  //       valueGetter: (row: ProductAllocationEntity, amountUnit?: number | null | undefined) =>
  //         row?.PurVal || row?.PurVal === 0
  //           ? `${formatToIndianCurrency(row?.PurVal, amountUnit)}`
  //           : 'N/A',
  //     },
  //     {
  //       header: 'Current Market Value',
  //       sortingKey: 'MktVal',
  //       valueGetter: (row: ProductAllocationEntity, amountUnit?: number | null | undefined) =>
  //         row?.MktVal || row?.MktVal === 0
  //           ? `${formatToIndianCurrency(row?.MktVal, amountUnit)}`
  //           : 'N/A',
  //     },
  //     {
  //       header: 'Invested Value %',
  //       sortingKey: 'PurValPercent',
  //       valueGetter: (row: ProductAllocationEntity) => row?.PurValPercent,
  //     },
  //     {
  //       header: 'Current Market Value %',
  //       sortingKey: 'MktValPercent',
  //       valueGetter: (row: ProductAllocationEntity) => row?.MktValPercent,
  //     },
  //   ];
  // };

  // const assetClassTableHeaders = (): ColumnType[] => {
  //   return [
  //     {
  //       header: 'Asset Class',
  //       sortingKey: 'Asset_Class',
  //       valueGetter: (row: AssetAllocationEntity) => row?.Asset_Class,
  //     },
  //     {
  //       header: 'Invested Value',
  //       sortingKey: 'PurVal',
  //       valueGetter: (row: AssetAllocationEntity, amountUnit?: number | null | undefined) =>
  //         row?.PurVal || row?.PurVal === 0
  //           ? `${formatToIndianCurrency(row?.PurVal, amountUnit)}`
  //           : 'N/A',
  //     },
  //     {
  //       header: 'Current Market Value',
  //       sortingKey: 'MktVal',
  //       valueGetter: (row: AssetAllocationEntity, amountUnit?: number | null | undefined) =>
  //         row?.MktVal || row?.MktVal === 0
  //           ? `${formatToIndianCurrency(row?.MktVal, amountUnit)}`
  //           : 'N/A',
  //     },
  //     {
  //       header: 'Invested Value %',
  //       sortingKey: 'PurValPercent',
  //       valueGetter: (row: AssetAllocationEntity) => row?.PurValPercent,
  //     },
  //     {
  //       header: 'Current Market Value %',
  //       sortingKey: 'MktValPercent',
  //       valueGetter: (row: AssetAllocationEntity) => row?.MktValPercent,
  //     },
  //   ];
  // };

  // function numDifferentiation(value: number) {
  //   const val = Math.abs(value);
  //   if (val >= 10000000) {
  //     return (val / 10000000).toFixed(2) + ' Cr';
  //   } else {
  //     return (val / 100000).toFixed(2) + ' Lac';
  //   }
  // }
  // //Graph refs
  // const assetAllocationRef = useRef(null);

  return (
    <div ref={componentRef}>
      <CommonLayout>
        <>
          {/* <Button
        // onClick={() => window.print()}
        onClick={handlePrint}

        className="print_button" 
            sx={{
              bgcolor: '#337FC9',
              borderRadius: '5px',
              fontWeight: 'normal',
              padding: 0,
              px: 1,
              '&:hover': { bgcolor: '#2868a6' },
            }}>
            PDF
          </Button>  */}
          {/* <Button
            onClick={() => window.print()}

            sx={{

              marginBottom: '10px',
              height: '27px',
              color: 'white',
              fontSize: '13px',
              cursor: 'pointer',
              borderRadius: '5px',
              bgcolor: '#4990F0',
              '&:hover': { backgroundColor: '#639FF0' },
            }}>Download   PDF <SaveAltRoundedIcon sx={{ fontSize: '20px', marginLeft: '8px' }} /></Button> */}

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '0.9rem' }}>
            <Box >
              <Typography sx={{ color: 'text.primary' }} variant='h1'>Dashboard</Typography>
            </Box>
            {/* <Box sx={{ marginBottom: "0.9rem" }}>
              <CustomDropdown IsLoading={isLoading} setFilterValue={setCardFilter} options={[
                {
                  "label": "Week",
                  "value": 1
                },
                {
                  "label": "Month",
                  "value": 2
                }
              ]} defaultValue={1} />
            </Box> */}

          </Box>

          {/* <Box
            sx={{
              display: 'flex',
              justifyContent: { xs: 'unset', lg: 'space-between' },
              flexWrap: 'wrap',
              gap: 1.5,
              mb: 1.5,
            }}>

            <InfoCard
              isLoading={isLoading}
              label={'Total AUM'}
              // value={formatNumberWithRupeeSymbol(showCard.reduce((prev, curr: GetCashHistory) => prev + curr.netAssets, 0))}
              value={formatNumberWithRupeeSymbol(latestObject?.netAssets)}
              // color={data?.color}
              // onClick={() => history.push('/investors')}
              chartData={cardFilter === 1 ? separateDataByMonth(lastYearData, 'netAssets').weekly : separateDataByMonth(lastYearData, 'netAssets').monthly}
              icon={
                <TotalAUMIcon />
              }
            />
            <InfoCard
              isLoading={isLoading}
              label={'Cash Available'}
              // value={formatNumberWithRupeeSymbol(showCard.reduce((prev, curr: GetCashHistory) => prev + curr.cashBalance, 0))}
              value={formatNumberWithRupeeSymbol(latestObject?.cashBalance)}
              // color={data?.color}
              // onClick={() => history.push('/investors')}
              chartData={cardFilter === 1 ? separateDataByMonth(lastYearData, 'cashBalance').weekly : separateDataByMonth(lastYearData, 'cashBalance').monthly}
              icon={<CashAvailableIcon />}
            />
            <InfoCard
              isLoading={isLoading}
              label={'Accounts'}
              value={latestObject?.noOfPortfolios}
              // value={showCard.reduce((prev, curr: GetCashHistory) => prev + curr.noOfPortfolios, 0)}
              // color={data?.color}
              // onClick={() => history.push('/investors')}
              chartData={cardFilter === 1 ? separateDataByMonth(lastYearData, 'noOfPortfolios').weekly : separateDataByMonth(lastYearData, 'noOfPortfolios').monthly}
              icon={<AccountsIcon sx={{ fontSize: { md: '0.9rem', lg: '1.406rem' } }} />}
            />
            <InfoCard
              isLoading={isLoading}
              label={'Holding'}
              // value={showCard.reduce((prev, curr: GetCashHistory) => prev + curr.noOfHoldings, 0)}
              value={latestObject?.noOfHoldings}
              // color={data?.color}
              // onClick={() => history.push('/investors')}
              chartData={cardFilter === 1 ? separateDataByMonth(lastYearData, 'noOfHoldings').weekly : separateDataByMonth(lastYearData, 'noOfHoldings').monthly}
              icon={
                <TotalAUMIcon sx={{ fontSize: { md: '0.9rem', lg: '1.406rem' } }} />
              }
            />

            
          </Box> */}

          <Grid container columnSpacing={2} rowSpacing={2} sx={{ mb: '25px', flexWrap: 'wrap' }}>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InfoCard
                isLoading={isLoading}
                label={'Total AUM'}
                // value={formatNumberWithRupeeSymbol(showCard.reduce((prev, curr: GetCashHistory) => prev + curr.netAssets, 0))}
                // value={formatNumberWithRupeeSymbol(latestObject?.netAssets)}
                value={latestObject?.netAssets < 0 ? `- ${formatCurrency({ value: Math.abs(latestObject?.netAssets ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: latestObject?.netAssets ?? 0, locale, currencyCode })}` || "-"}
                // color={data?.color}
                // onClick={() => history.push('/investors')}
                // chartData={cardFilter === 1 ? separateDataByMonth(lastYearData, 'netAssets').weekly : separateDataByMonth(lastYearData, 'netAssets').monthly}
                icon={
                  <TotalAUMIcon />
                }

              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InfoCard
                isLoading={isLoading}
                label={'Cash Available'}
                // value={formatNumberWithRupeeSymbol(showCard.reduce((prev, curr: GetCashHistory) => prev + curr.cashBalance, 0))}
                value={latestObject?.cashBalance < 0 ? `- ${formatCurrency({ value: Math.abs(latestObject?.cashBalance ?? 0), locale, currencyCode })}` : `${formatCurrency({ value: latestObject?.cashBalance ?? 0, locale, currencyCode })}` || "-"}
                // value={formatNumberWithRupeeSymbol(latestObject?.cashBalance)}
                // color={data?.color}
                // onClick={() => history.push('/investors')}
                // chartData={cardFilter === 1 ? separateDataByMonth(lastYearData, 'cashBalance').weekly : separateDataByMonth(lastYearData, 'cashBalance').monthly}
                icon={<CashAvailableIcon />}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InfoCard
                isLoading={isLoading}
                label={'Accounts'}
                value={latestObject?.noOfCustomers || "-"}
                // value={showCard.reduce((prev, curr: GetCashHistory) => prev + curr.noOfPortfolios, 0)}
                // color={data?.color}
                // onClick={() => history.push('/investors')}
                // chartData={cardFilter === 1 ? separateDataByMonth(lastYearData, 'noOfPortfolios').weekly : separateDataByMonth(lastYearData, 'noOfPortfolios').monthly}
                icon={<AccountsIcon />}
              />
            </Grid>
            <Grid item xs={12} sm={6} md={4} lg={3}>
              <InfoCard
                isLoading={isLoading}
                label={'Holding'}
                // value={showCard.reduce((prev, curr: GetCashHistory) => prev + curr.noOfHoldings, 0)}
                value={latestObject?.noOfHoldings || "-"}
                // color={data?.color}
                // onClick={() => history.push('/investors')}
                // chartData={cardFilter === 1 ? separateDataByMonth(lastYearData, 'noOfHoldings').weekly : separateDataByMonth(lastYearData, 'noOfHoldings').monthly}
                icon={
                  <TotalHoldingsIcon />
                }
              />
            </Grid>
          </Grid>

          <Grid container columnSpacing={3} rowSpacing={3}>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Box component={'div'} sx={{
                width: '100%',
                padding: '25px 30px 45px 30px',
                borderRadius: '20px',
                background: '#ffffff',
                boxShadow: '0px 4px 10px 0px #0000000D',
                height: '100%',
              }} >
                {/* <Box component={'div'} sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  // background: 'blue',
                  height: '100%',
                }}>
                 
                </Box> */}
                <Box component={'div'} sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                  <Typography variant='h2' sx={{
                    fontWeight: 600,
                    fontSize: 20,
                  }}>Asset Allocation

                  </Typography>
                  {/* {assetAllocation?.data?.length !== 0 && */}
                  <CustomDropdown setFilterValue={setassetFilter} IsLoading={assetLoading} options={[
                    {
                      "label": "By Product",
                      "value": 1
                    },
                    {
                      "label": "By Asset Class",
                      "value": 2
                    }
                  ]} defaultValue={1} />
                  {/* } */}

                </Box>

                <Box sx={{
                  // background: 'red'
                  height: "100%",
                  display: 'flex',
                  alignItems: "center"
                }}>

                  {!pieChartError && assetAllocation?.data?.length !== 0 ? <CustomePieChart {...{ ...assetAllocation, isLoading: assetLoading, showSlider: true, title: 'Asset Allocation' }} /> : <ErrorText />}
                </Box>
                {/* </Box> */}
              </Box>
            </Grid>
            <Grid item lg={6} md={6} sm={12} xs={12}>
              <Box sx={{
                width: '100%',
                // paddingBottom: '45px',
                borderRadius: '20px',
                background: '#ffffff',
                boxShadow: '0px 4px 10px 0px #0000000D',
                height: '100%'
              }}>
                {
                  <CustomeLineChart
                    isLoading={isLoading}
                    setFilterValue={setFilterValue}
                    data={filterValue === 2 ? {
                      name: [...(aumData.aum?.family?.name ?? [])],
                      value: [...(aumData.aum?.family?.value ?? [])]
                    } as any : {
                      name: [...(aumData?.aum?.individual?.name ?? [])],
                      value: [...(aumData?.aum?.individual?.value ?? [])]
                    } as any}
                    filterOption={aumData.filterOption as any}
                    error={aumDistributionError}
                    aumAmount={latestObject?.netAssets}
                  />}

              </Box>

            </Grid>
          </Grid>
          <Account {...{ isLoading, accountTable, aumAmount: latestObject?.netAssets, error: aumDistributionError, exportData }} />

          {/* <WorldMap {...{ isLoading }} /> */}
          {/* <div ref={componentRef}> */}

          {/* <Box
            ref={assetAllocationRef}
            sx={{
              background: ' #FFFFFF',
              boxShadow: '0px 4px 28px 2px rgba(0, 0, 0, 0.08)',
              borderRadius: '5px',
            }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                px: 3,
                py: 1,
              }}>
              <Typography
                sx={{
                  color: '#22242C',
                  opacity: 0.8,
                  fontSize: 16,
                  lineHeight: '19px',
                  fontWeight: 600,
                }}>
                Asset Allocation
              </Typography>
              <Stack direction="row" alignItems="center">
                <Box sx={{ pr: 2 }}>
                  <AmountUnit />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', mx: 1 }}>

                  <Typography
                    sx={{
                      color: '#22242C',
                      opacity: 0.8,
                      fontSize: 15,
                      fontWeight: 500,
                    }}>
                    By Product
                  </Typography>
                  <Switch
                    checked={selectedAssetsType === 'assetClass'}
                    onChange={(_, checked) =>
                      setSelectedAssetsType(checked ? 'assetClass' : 'product')
                    }
                    sx={{
                      p: 0,
                      mx: 2.5,
                      height: 20,
                      width: 52,
                      '& .MuiSwitch-track': {
                        background: '#4990F0',
                        opacity: 1,
                        borderRadius: '12px',
                      },
                      '& .MuiSwitch-thumb': { border: '1px solid #E1D8D8' },
                      '& .MuiSwitch-switchBase': {
                        p: 0,
                        '&.Mui-checked': {
                          color: '#fff',
                          transform: 'translateX(32px)',
                          '& + .MuiSwitch-track': {
                            backgroundColor: '#4990F0',
                            opacity: 1,
                          },
                        },
                      },
                    }}
                  />
                  <Typography
                    sx={{
                      color: '#22242C',
                      opacity: 0.8,
                      fontSize: 15,
                      fontWeight: 500,
                    }}>
                    By Asset Class
                  </Typography>
                </Box>


              </Stack>
            </Box>
            <Divider />
            <Box sx={{ padding: '10px 35px', display: 'flex', justifyContent: 'flex-end' }}>
              <FlipIcon
                onClick={() => setFlip(!flip)}
                style={{
                  height: '20px',
                  cursor: 'pointer',
                  // background: 'white',
                  // marginLeft:"20px",
                  // marginTop:"8px",
                  // border:'none'
                }}
              />
            </Box>
            <ReactCardFlip isFlipped={flip} flipDirection="horizontal">
              <div
                style={{
                  backgroundColor: 'white',
                  display: `${flip ? 'none' : 'block'}`
                }}>
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    p: 2,
                    justifyContent: 'center',
                    width: '100%',
                  }}>
                  <Box sx={{ display: 'flex', width: '100%' }}>
                    <Box style={{ width: '50%', textAlign: 'right', paddingRight: '20px' }}>
                      <Typography
                        sx={{
                          fontSize: 14,
                          color: '#22242C',
                          opacity: 0.8,
                          mb: 1,
                          textAlign: 'right',
                        }}>
                        Invested Value
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 20,
                          color: '#11263C',
                          mb: 3.5,
                          fontWeight: 700,
                          textAlign: 'right',
                        }}>
                        {isLoading ? (
                          <Skeleton />
                        ) : (
                          ` ${(dashBoardMetricsData?.assetAllocation &&
                            dashBoardMetricsData?.assetAllocation[0]?.TotalInvesVal &&
                            formatToIndianCurrency(
                              dashBoardMetricsData?.assetAllocation[0]?.TotalInvesVal,
                              valueConverter
                            )) ||
                          'NA'
                          }`
                        )}
                      </Typography>
                    </Box>
                    <Box style={{ width: 150, textAlign: 'center' }}></Box>
                    <Box style={{ width: '50%', paddingLeft: '20px' }}>
                      <Typography
                        sx={{
                          fontSize: 14,
                          color: '#22242C',
                          opacity: 0.8,
                          mb: 1,
                        }}>
                        Current Market Value
                      </Typography>
                      <Typography
                        sx={{
                          fontSize: 20,
                          color: '#11263C',
                          mb: 3.5,
                          fontWeight: 700,
                        }}>
                        {isLoading ? (
                          <Skeleton />
                        ) : (
                          ` ${(dashBoardMetricsData?.assetAllocation &&
                            dashBoardMetricsData?.assetAllocation[0]?.TotalMktVal &&
                            formatToIndianCurrency(
                              dashBoardMetricsData?.assetAllocation[0]?.TotalMktVal,
                              valueConverter
                            )) ||
                          'NA'
                          }`
                        )}
                      </Typography>
                    </Box>
                  </Box>

                  {selectedAssetsType === 'assetClass' && dashBoardMetricsData?.assetAllocation
                    ? dashBoardMetricsData?.assetAllocation.map((asset, index: number) => (
                      <AssetAllocationCard
                        key={index}
                        label={asset?.Asset_Class || ''}
                        investedPercent={asset?.PurValPercent || ''}
                        currentPercent={asset?.MktValPercent || ''}
                        investedValue={asset?.PurVal || ''}
                        currentValue={asset?.MktVal || ''}
                        labelStyles={{ border: 0 }}
                      />
                    ))
                    : selectedAssetsType === 'product' && dashBoardMetricsData?.productAllocation
                      ? dashBoardMetricsData?.productAllocation.map((asset, index: number) => (
                        <AssetAllocationCard
                          key={index}
                          label={asset?.ProductLevel}
                          investedPercent={asset?.PurValPercent}
                          currentPercent={asset?.MktValPercent}
                          investedValue={asset?.PurVal}
                          currentValue={asset?.MktVal}
                        />
                      ))
                      : [...Array(3)].map((asset: any, index: number) => (
                        <AssetAllocationCard
                          key={index}
                          label={asset?.ProductLevel}
                          investedPercent={asset?.PurValPercent}
                          currentPercent={asset?.MktValPercent}
                          investedValue={asset?.PurVal}
                          currentValue={asset?.MktVal}
                          isLoading={true}
                        />
                      ))}
                </Box>
              </div>
              <div
                style={{
                  width: '100%',
                  backgroundColor: 'white',
                  maxHeight: '390px',
                  display: `${flip ? 'block' : 'none'}`
                }}>
                {selectedAssetsType === 'product' ? (
                  <DataTable
                    isLoading={isLoading}
                    tableHeader={[...productTableHeaders()]}
                    tableData={
                      dashBoardMetricsData?.productAllocation &&
                      dashBoardMetricsData?.productAllocation
                    }
                    rowCustomStyles={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      '.MuiTableCell-body ': { color: '#686e72' },
                      '& .MuiTableCell-root': {
                        textAlign: 'left',
                      },
                    }}
                    tableHeaderCustomStyles={{
                      '& .MuiTableCell-root': {
                        textAlign: 'left',
                      },
                    }}
                    boxStyles={{ minHeight: '500px', minWidth: 450 }}
                  />
                ) : (
                  <DataTable
                    isLoading={isLoading}
                    tableHeader={[...assetClassTableHeaders()]}
                    tableData={
                      dashBoardMetricsData?.assetAllocation
                      // &&
                      // dashBoardMetricsData?.rmWise.filter((ele) =>
                      //   ele?.RMID?.toLowerCase().includes(search.toLowerCase())
                      // )
                    }
                    rowCustomStyles={{
                      '&:last-child td, &:last-child th': { border: 0 },
                      '.MuiTableCell-body ': { color: '#686e72' },
                      '& .MuiTableCell-root': {
                        textAlign: 'left',
                      },
                    }}
                    tableHeaderCustomStyles={{
                      '& .MuiTableCell-root': {
                        textAlign: 'left',
                      },
                    }}
                    boxStyles={{ minHeight: '500px', minWidth: 450 }}
                  />
                )}
              </div>
            </ReactCardFlip>
          </Box> */}


        </>
      </CommonLayout>
    </div>
  );
}
